// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__frVfv","title":"ClientReferral_title__7E2HU","itemText":"ClientReferral_itemText__3ka-f"};